<div *ngIf="loading">
  <deltacapita-content-loader></deltacapita-content-loader>
</div>
<div *ngIf="!loading">
  <form [formGroup]="editDistributorContactForm" (ngSubmit)="updateDistributorContact()">
    <div class="form-group icon">
      <app-dc-input
        formControlName="name"
        type="text"
        label="Name"
        [placeholder]="contactToBeEdited.name"
      ></app-dc-input>
    </div>

    <div class="form-group icon">
      <app-dc-select
        label="Distributor(s)"
        [labelId]="'distributor'"
        [placeholder]="'Select Distributor(s)'"
        [items]="distributorsDropdownData"
        [checkbox]="true"
        formControlName="distributors"
        [disabled]="false"
        [multiple]="true"
        [searchable]="true"
      ></app-dc-select>
    </div>

    <div class="form-group icon">
      <app-dc-select
        label="Region(s)"
        [labelId]="'region'"
        [placeholder]="'Select Region(s)'"
        [items]="regionsDropdownData"
        [checkbox]="true"
        formControlName="region"
        [disabled]="false"
        [multiple]="true"
        [searchable]="false"
      ></app-dc-select>
    </div>

    <div class="form-group icon">
      <app-dc-input
        formControlName="email"
        type="text"
        label="Email"
        [placeholder]="contactToBeEdited.email"
      ></app-dc-input>
    </div>
    <div class="form-group icon">
      <app-dc-input
        formControlName="tel"
        type="text"
        label="Telephone (optional)"
        [placeholder]="contactToBeEdited.tel"
      ></app-dc-input>
    </div>
    <div class="form-group icon">
      <app-dc-input
        formControlName="mobile"
        type="text"
        label="Mobile (optional)"
        [placeholder]="contactToBeEdited.mobile"
      ></app-dc-input>
    </div>

    <br />
    <div class="m-3 d-flex align-items-center justify-content-center">
      <button class="btn btn-primary" type="submit" [disabled]="!editDistributorContactForm.valid">
        Update Distributor Contact
      </button>
    </div>
  </form>
</div>
